import { createContext } from "react"

export type JWTContainer = {
  logout: () => Promise<void>
  refresh: () => Promise<void>
}

export const JWTContext = createContext<JWTContainer>(undefined as any)
